import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
// import eruda from 'eruda'

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
)

const language = localStorage.getItem('language') || 'ru'
i18next.use(initReactI18next).init({
	resources: {
		ru: {
			translation: {
				Welcome:
					"Добро пожаловать в приложение онлайн-мониторинг O'zbekiston Temir yo'llari!",
				Monitoring: 'Мониторинг',
				Search: 'Поиск',
				'Sensors Group': 'Группы датчиков',
				'Have a nice day!': 'Хорошего дня!',
				Heating: 'Отопление',
				'High voltage heating 3000 V':
					'Высоковольтное отопление 3000 В',
				ElectricHeater: 'Электрический калорифер',
				LowVoltHeater: 'Низковольтное отопление',
				Conditioning: 'Кондиционирование',
				ClimateControl: 'Климат контроль',
				Auto: 'Авто',
				Manual: 'Ручной',
				Specified: 'Заданная',
				Coupe: 'Купе',
				Outdoor: 'Наружная',
				SupplyFan: 'Приточный вентилятор',
				HighPressure: 'Высокое давление',
				LowPressure: 'Низкое давление',
				CompressorFrequency: 'Частота компрессора',
				'Damper 1 open': 'Заслонка 1 открыта',
				'Damper 1 closed': 'Заслонка 1 закрыта',
				'Damper 2 open': 'Заслонка 2 открыта',
				'Damper 2 closed': 'Заслонка 2 закрыта',
				WaterBoiler: 'Водонагреватель',
				Temperature: 'Температура',
				Aqualite: 'Аквалит',
				Megalith: 'Мегалит',
				Megalit: 'Мегалит',
				'Drinking water tank': 'Бак питьевой воды',
				MainLightning: 'Основное освещение',
				EmergencyLighting: 'Дежурное освещение',
				'Enter/exit': 'Вход/выход',
				Capacitor: 'Конденсатор',
				Compressor: 'Компрессор',
				HighHeat: 'Высоковольтное отопление',
				LowHeat: 'Низковольтное отопление',
				Calorifer: 'Калорифер',
				Climate: 'Климат',
				RNG: 'РНГ',
				PCH: 'ПЧ',
				ThermalSensors: 'Термодатчики',
				ThermalSensor: 'Термодатчик',
				Timers: 'Таймеры',
				SensorInversion: 'Инверсия датчика',
				WaterAvailablity: 'Наличие воды',
				WaterTemperature: 'Температура воды',
				WaterTank: 'Бак воды',
				PressureSensors: 'Датчики давления',
				SensorNotConfigured: 'Обрыв датчика',
				SensorHighConfigured: 'Датчик высокого давления',
				SensorLowConfigured: 'Датчик низкого давления',
				ResetResource: 'Сброс ресурса',
				Status: 'Статус',
				LastSeenAt: 'Последняя связь',
				DELIXI: 'DELIXI',
				NoAccidents: 'Нет аварий',
				RNGSensors: 'Датчики РНГ',
				ExcitationWinding: 'Возбуждение обмотки',
				Controller: 'Контроллер',
				CarrierSpeed: 'Скорость вагона',
				BatteryType: 'Тип батареи',
				BatteryTemperature: 'Температура батареи',
				CheckTheBalance: 'Проверьте баланс',
				Power: 'Питание',
				Battery: 'Батарея',
				Батарея: 'Батарея',
				Генератор: 'Генератор',
				VoltageNetwork: 'Напр. сети',
				Volt: 'В',
				Degree: '°C',
				AmperageNetwork: 'Ток сети',
				Amp: 'А',
				AmperageBattery: 'Ток батареи',
				TemperatureBattery: 'Темп. батареи',
				Control: 'Управление',
				ControllerManagement: 'Управление контроллером',
				RNGControl: 'Управление РНГ',
				InternalCommunication: 'Внутренняя связь',
				LeftDoor: 'Левая дверь',
				RightDoor: 'Правая дверь',
				Protection: 'Защита',
				VTS: 'ВТС',
				VTB: 'ВТБ',
				VNS: 'ВНС',
				'MIN.1': 'МИН.1',
				'MIN.2': 'МИН.2',
				SideProtOver: 'Перегрев буксы',
				Carriers: 'Вагоны',
				NewCarrier: 'Новый вагон',
				Loading: 'Загрузка',
				CurrentIndications: 'Текущие показания',
				Logging: 'Логирование',
				Diagram: 'Диаграмма',
				Description: 'Описание',
				Submit: 'Сохранить',
				changePassword: 'Изменить пароль',
				oldPassword: 'Старый пароль',
				newPassword: 'Новый пароль',
				confirmPassword: 'Подтвердите пароль',
				Cancel: 'Отмена',
				'INPUT №': 'ВХОД №',
				'OUTPUT №': 'ВЫХОД №',
				Notifications: 'Уведомления',
				MarkAllAsRead: 'Отметить все как прочитанные',
				uploadPhoto: 'Загрузить фото',
				MaximalVoltage: 'Максимальное напряжение',
				ViewCarrier: 'Просмотр вагона',
				Name: 'Название',
				FactoryNumber: 'Заводской номер',
				Save: 'Сохранить',
				IsDeleted: 'Удален',
				Delete: 'Удалить',
				Restore: 'Восстановить',
				Redirecting: 'Перенаправление',
				Login: 'Вход',
				ProfileImage: 'Изображение профиля',
				fullname: 'ФИО',
				position: 'Должность',
				role: 'Роль',
				Sensors: 'Датчики',
				AddingNewSensor: 'Добавление нового датчика',
				Code: 'Код',
				Measurement: 'Измерение',
				Type: 'Тип',
				ViewSensor: 'Просмотр датчика',
				ViewUser: 'Просмотр пользователя',
				AddUser: 'Добавить пользователя',
				Email: 'Электронная почта',
				Users: 'Пользователи',
				UserName: 'Имя пользователя',
				Logout: 'Выход',
				Home: 'Главная',
				Lightning: 'Освещение',
				Consumers: 'Потребители',
				Climat: 'Климат',
				Settings: 'Настройки',
				MaxNetworkVoltage: 'Макс. напряжение сети',
				NetworkVoltage: 'Напряжение сети',
				NetworkCurrent: 'Ток сети',
				BatteryCurrent: 'Ток батареи',
				Timer: 'Таймер',
				'WorkTime 1': 'Наработка 1',
				'WorkTime 2': 'Наработка 2',
				sec: 'сек',
				hour: 'час',
				'StopDC-DC': 'Стоп DC-DC',
				ChargeCapacitor: 'Заряд конденсатора',
				'StartDC-DC': 'Старт DC-DC',
				'WorkDC-DC': 'Работа DC-DC',
				Work380V: 'Работа 380 В',
				NotEnoughVoltage: 'Недос. напряжения',
				PCHDrawerOpen: 'Открыт ящик ПЧ',
				StopSupply: 'Стоп приточка',
				StartSupply: 'Старт приточка',
				WorkSupply: 'Работа приточка',
				Overvoltage: 'Перенапряжение',
				'DC-DCFault': 'Неисправность DC-DC',
				StopCondensator: 'Стоп конденсатор',
				StartCondensator: 'Старт конденсатора',
				WorkCondensator: 'Работа конденсатора',
				HighCurrent: 'Высокий ток',
				Overheat75: 'Перегрев>75°',
				StopCompressor: 'Стоп компрессор',
				StartCompressor: 'Старт компрессор',
				WorkCompressor: 'Работа компрессор',
				ProtectionTemp: 'Защита по темп.',
				AnalogModule: 'Аналоговый модуль',
				inputVoltage: 'Входное напряжение',
				DrawerTemp: 'Температура ящика',
				Chastota: 'Частота',
				Voltage: 'Напряжение',
				Current: 'Ток',
				'DC-DCVoltage': 'DC-DC напряжение',
				Hz: 'Гц',
				InputAmper: 'Входной ток',
				VoltageAdjustment110: 'Подстройка напряжение 110 В',
				VoltageAdjustment450: 'Подстройка напряжение 450 В',
				MaximalCurrent: 'Максимальный ток',
				CurrentSensorAdjustment: 'Подстройка тока датчика',
				TempSensorAdjustment:
					'Подстройка температуры датчика',
				Work: 'Работа',
				CarrierName: 'Название вагона',
				CanView: 'Может просматривать',
				CanViewSettings: 'Доступ к настройкам',
				EditCarrier: 'Редактирование вагона',
				Actions: 'Действия',
				NoResults: 'Нет результатов',
				Balance: 'Баланс',
				ReplanishmentDate: 'Дата пополнения',
				BalanceOfCarrier: 'Баланс вагона',
				WaterOverheat: 'Перегрев воды',
				LastUpdate: 'Последнее обновление',
				UpdateNow: 'Обновить сейчас',
				CarrierPermission: 'Разрешение на вагон',
				'Coming Soon!': 'Скоро!',
				Time: 'Время',
				Source: 'Источник',
				Lighting: 'Освещение',
				'PCH Overheat': 'Перегрев ПЧ',
				Aqualit: 'Аквалит',
				Remote: 'Удаленно',
				App: 'Приложение',
				HVHeating: 'В/В отоп.',
				EventText: 'Текст события',
				EventLog: 'Журнал событии',
				AllCarriers: 'Все вагоны',
				TotalEvents: 'Всего событий',
				Filtered: 'Отфильтровано',
				Refresh: 'Обновить',
				Export: 'Экспорт',
				Total: 'Итого',
				Recent: 'Свежие',
				ViewAll: 'Посмотреть все',
				UniqueEvents: 'Уникальных',
				First: 'Первое',
				LoggingCodes: 'Коды логирования',
				AddCode: 'Добавить код',
				EditCode: 'Редактировать код',
				IsError: 'Ошибка',
				Notify: 'Уведомление',
				ConfirmDelete: 'Вы уверены, что хотите удалить?',
				Edit: 'Редактировать',
				SavedSuccessfully: 'Сохранено успешно',
				CreatedSuccessfully: 'Создано успешно',
				CodeRequired: 'Введите код',
				DeletedSuccessfully: 'Удалено успешно',
				ErrorLoadingData: 'Ошибка загрузки данных',
				ErrorDeletingData: 'Ошибка удаления данных',
				FireDamperOpen: 'Пожарная заслонка открыто',
				FireDamperClosed: 'Пожарная заслонка закрыта',
				FireDamperNotOpened: 'Не открылась пожарная заслонка',
				'New sensor data in carrier № ':
					'Новые данные датчика в вагоне № ',
				'Click to see more': 'Нажмите, чтобы увидеть больше',
				SelectCarrier: 'Выберите вагон',
				TestMode: 'ТЕСТОВЫЙ РЕЖИМ',
				LastCarrierData: 'Последние данные вагона',
				LastCarrierDataAll: 'Все последние данные вагонов',
				ShowLastUpdatedFirst:
					'Показывать последние обновленные в начале',
				NoData: 'Нет данных',
				ERR: 'Авария: ',
				Yes: 'Да',
				No: 'Нет',
				Continue: 'Продолжить',
				GoAhead: 'Вперед!',
				GoHome: 'На главную',
				GoBack: 'Назад',
				PageNotFound:
					'Извините, страница, которую вы посетили, не существует.',
				'Authentication Required': 'Требуется аутентификация',
				'To access this content, you need to authenticate first. Please login through SmartDepo platform to acquire the necessary tokens.':
					'Для доступа к этому контенту необходимо сначала пройти аутентификацию. Пожалуйста, войдите через платформу SmartDepo, чтобы получить необходимые токены.',
				'Authentication URL': 'URL аутентификации',
				'Refresh Page': 'Обновить страницу',
				'Login Now': 'Войти сейчас',
				'After successful authentication, your tokens will be automatically stored and you can access the content.':
					'После успешной аутентификации ваши токены будут автоматически сохранены, и вы сможете получить доступ к контенту.',
				'Refreshing Tokens...': 'Обновление токенов...',
				'Please wait while we refresh your authentication tokens...':
					'Пожалуйста, подождите, пока мы обновляем ваши токены аутентификации...',
				'Try Refresh Token': 'Попробовать обновить токен',
				Online: 'Онлайн',
				Offline: 'Офлайн',
				NetworkPanelDisconnected: 'Нет связи с пультом',
				NetworkPanelAlertTitle: 'Нет связи с пультом',
				NetworkPanelAlertBody:
					'Потеряна связь со следующими вагонами:',
				Acknowledge: 'Принято',
				Count: 'Кол-во'
			}
		},
		uz: {
			translation: {
				Welcome:
					"O'zbekiston Temir Yo'llari onlayn monitoring ilovasiga xush kelibsiz!",
				Monitoring: 'Monitoring',
				Search: 'Qidirish',
				'Sensors Group': 'Sensorlar guruhi',
				'Have a nice day!': "Kuningiz yaxshi o'tsin!",
				Heating: 'Isitish',
				'High voltage heating 3000 V':
					'Yuqori quvvatli isitish 3000 V',
				ElectricHeater: 'Elektr isitgich',
				LowVoltHeater: 'Past quvvatli isitish',
				Conditioning: 'Konditsioner',
				ClimateControl: 'Iqlim nazorati',
				Auto: 'Avto',
				Manual: 'Ruchnoy',
				Specified: "Ko'rsatilgan",
				Coupe: 'Kupe',
				Outdoor: 'Tashqari',
				SupplyFan: 'Taminotchi quvurlar',
				HighPressure: 'Yuqori bosim',
				LowPressure: 'Past bosim',
				CompressorFrequency: 'Kompressor chastotasi',
				'Damper 1 open': 'Zaslonka 1 ochiq',
				'Damper 1 closed': 'Zaslonka 1 yopiq',
				'Damper 2 open': 'Zaslonka 2 ochiq',
				'Damper 2 closed': 'Zaslonka 2 yopiq',
				WaterBoiler: 'Suv isitgich',
				Temperature: 'Harorat',
				Aqualite: 'Aqualit',
				Megalith: 'Megalit',
				Megalit: 'Megalit',
				'Drinking water tank': 'Ichimlik suvi tanki',
				MainLightning: "Asosiy yorug'lik",
				EmergencyLighting: "Avariyalik yorug'lik",
				'Enter/exit': 'Kirish/chiquvchi',
				Capacitor: 'Kondensator',
				Compressor: 'Kompressor',
				HighHeat: 'Yuqori isitish',
				LowHeat: 'Past isitish',
				Calorifer: 'Kalorifer',
				Climate: 'Iqlim',
				RNG: 'RNG',
				PCH: 'PCH',
				ThermalSensors: 'Termo sensorlar',
				ThermalSensor: 'Termo sensor',
				Timers: 'Taymerlar',
				SensorInversion: 'Sensor inversiyasi',
				WaterAvailablity: 'Suv mavjudligi',
				WaterTemperature: 'Suv harorati',
				WaterTank: 'Suv tanki',
				PressureSensors: 'Bosim sensorlari',
				SensorNotConfigured: 'Sensorning sinishi',
				SensorHighConfigured: 'Yuqori bosim sensori',
				SensorLowConfigured: 'Past bosim sensori',
				ResetResource: 'Resursni tiklash',
				Status: 'Holat',
				LastSeenAt: "So'nggi aloqa",
				DELIXI: 'DELIXI',
				NoAccidents: "Aksidentlar yo'q",
				RNGSensors: 'RNG sensorlari',
				ExcitationWinding: "Kuchlantirish o'simligi",
				Controller: 'Boshqaruvchi',
				CarrierSpeed: 'Yuk tizimi tezligi',
				BatteryType: 'Batareya turi',
				BatteryTemperature: 'Batareya harorati',
				CheckTheBalance: 'Balansni tekshiring',
				Power: 'Quvvat',
				Battery: 'Batareya',
				Батарея: 'Batareya',
				Генератор: 'Generator',
				VoltageNetwork: 'Tarmoq quvvati',
				Volt: 'V',
				Degree: '°C',
				AmperageNetwork: 'Tarmoq amperaji',
				Amp: 'А',
				AmperageBattery: 'Batareya amperaji',
				TemperatureBattery: 'Batareya harorati',
				Control: 'Boshqarish',
				ControllerManagement: 'Boshqaruvchi boshqarish',
				RNGControl: 'RNG boshqarish',
				InternalCommunication: 'Ichki aloqa',
				LeftDoor: 'Chap eshik',
				RightDoor: "O'ng eshik",
				Protection: 'Himoya',
				VTS: 'VTS',
				VTB: 'VTB',
				VNS: 'VNS',
				'MIN.1': 'MIN.1',
				'MIN.2': 'MIN.2',
				SideProtOver: 'Bukslarning qizishi',
				Carriers: 'Vagonlar',
				NewCarrier: 'Yangi vagon',
				Loading: 'Yuklanmoqda',
				CurrentIndications: "Joriy ko'rsatmalar",
				Logging: 'Logging',
				Diagram: 'Diagramma',
				Description: 'Tavsif',
				Submit: 'Saqlash',
				changePassword: "Parolni o'zgartirish",
				oldPassword: 'Eski parol',
				newPassword: 'Yangi parol',
				confirmPassword: 'Parolni tasdiqlang',
				Cancel: 'Bekor qilish',
				'INPUT №': 'KIRISH №',
				'OUTPUT №': 'CHIQISH №',
				Notifications: 'Bildirishnomalar',
				MarkAllAsRead: "Barchasini o'qilgan deb belgilang",
				uploadPhoto: 'Rasm yuklash',
				MaximalVoltage: 'Maksimal quvvat',
				ViewCarrier: "Vagonni ko'rish",
				Name: 'Nomi',
				FactoryNumber: 'Zavod raqami',
				Save: 'Saqlash',
				IsDeleted: "O'chirilgan",
				Delete: "O'chirish",
				Restore: 'Qayta tiklash',
				Redirecting: "Yo'naltirish",
				Login: 'Kirish',
				ProfileImage: 'Profil rasmi',
				fullname: 'FIO',
				position: 'Lavozim',
				role: 'Rol',
				Sensors: 'Sensorlar',
				AddingNewSensor: "Yangi sensor qo'shish",
				Code: 'Kod',
				Measurement: "O'lchov",
				Type: 'Turi',
				ViewSensor: "Sensorni ko'rish",
				ViewUser: "Foydalanuvchini ko'rish",
				AddUser: "Foydalanuvchi qo'shish",
				Email: 'Elektron pochta',
				Users: 'Foydalanuvchilar',
				UserName: 'Foydalanuvchi nomi',
				Logout: 'Chiqish',
				Home: 'Bosh sahifa',
				Lightning: "Yorug'lik",
				Consumers: 'Istemolchilar',
				Climat: 'Iqlim',
				Settings: 'Sozlamalar',
				MaxNetworkVoltage: 'Maksimal tarmoq quvvati',
				NetworkVoltage: 'Tarmoq quvvati',
				NetworkCurrent: 'Tarmoq amperaji',
				BatteryCurrent: 'Batareya amperaji',
				Timer: 'Taymer',
				'WorkTime 1': 'Ish vaqti 1',
				'WorkTime 2': 'Ish vaqti 2',
				sec: 'sek',
				hour: 'soat',
				'StopDC-DC': 'Stop DC-DC',
				ChargeCapacitor: 'Kondensator zaryadi',
				'StartDC-DC': 'DC-DC start',
				'WorkDC-DC': 'DC-DC ish',
				Work380V: '380 V ish',
				NotEnoughVoltage: 'Quvvat yetarli emas',
				PCHDrawerOpen: 'PCH yashigi ochiq',
				StopSupply: 'Stop pritojka',
				StartSupply: 'Pritojka start',
				WorkSupply: 'Pritojka ish',
				Overvoltage: 'Ortiqcha kuchlanish',
				'DC-DCFault': 'DC-DCda xatolik',
				StopCondensator: 'Stop kondensator',
				StartCondensator: 'Kondensator start',
				WorkCondensator: 'Kondensator ish',
				HighCurrent: 'Yuqori tok',
				Overheat75: '75° qizib ketish',
				StopCompressor: 'Stop kompressor',
				StartCompressor: 'Kompressor start',
				WorkCompressor: 'Kompressor ish',
				ProtectionTemp: "°C bo'yicha himoya",
				AnalogModule: 'Analog modul',
				inputVoltage: 'Kirish quvvati',
				DrawerTemp: 'Yashik harorati',
				Chastota: 'Chastota',
				Voltage: 'Quvvat',
				Current: 'Tok',
				'DC-DCVoltage': 'DC-DC quvvati',
				Hz: 'Gts',
				InputAmper: 'Kirish amperaji',
				VoltageAdjustment110: '110 V quvvatini moslash',
				VoltageAdjustment450: '450 V quvvatini moslash',
				MaximalCurrent: 'Maksimal tok',
				CurrentSensorAdjustment: 'Sensor amperajini moslash',
				TempSensorAdjustment: 'Sensor haroratini moslash',
				Work: 'Ish holatida',
				CarrierName: 'Vagon nomi',
				CanView: "Ko'rishi mumkin",
				CanViewSettings: 'Sozlamalar',
				EditCarrier: 'Vagonni tahrirlash',
				Actions: 'Harakatlar',
				NoResults: 'Natijalar yoq',
				Balance: 'Balans',
				ReplanishmentDate: "To'ldirish sanasi",
				BalanceOfCarrier: 'Vagon balansi',
				WaterOverheat: 'Suv qizib ketishi',
				LastUpdate: "So'nggi yangilanish",
				UpdateNow: 'Hozir yangilash',
				CarrierPermission: "Vagon bo'yicha ruxsat",
				'Coming Soon!': 'Tez orada!',
				Time: 'Vaqt',
				Source: 'Manba',
				Lighting: 'Yoritish',
				'PCH Overheat': 'PCH qizib ketishi',
				Aqualit: 'Aqualit',
				Remote: 'Masofaviy',
				App: 'Ilova',
				EventText: 'Voqea mazmuni',
				EventLog: 'Voqealar jurnali',
				AllCarriers: 'Barcha vagonlar',
				TotalEvents: 'Jami voqealar',
				Filtered: 'Saralandi',
				Refresh: 'Yangilash',
				Export: 'Chiqarish',
				Total: 'Jami',
				Recent: "So'ngi",
				ViewAll: "Barchasini ko'rish",
				UniqueEvents: 'Noyob',
				First: 'Birinchi',
				LoggingCodes: 'Logging kodlari',
				AddCode: "Kod qo'shish",
				EditCode: 'Kodni tahrirlash',
				IsError: 'Xatolik',
				Notify: 'Bildirishnoma',
				ConfirmDelete: "O'chirishni tasdiqlaysizmi?",
				Edit: 'Tahrirlash',
				SavedSuccessfully: 'Muvaffaqiyatli saqlandi',
				CreatedSuccessfully: 'Muvaffaqiyatli yaratildi',
				CodeRequired: 'Kodni kiriting',
				DeletedSuccessfully: "Muvaffaqiyatli o'chirildi",
				ErrorLoadingData: "Ma'lumotlarni yuklashda xatolik",
				ErrorDeletingData: "O'chirishda xatolik",
				FireDamperClosed: "Yong'in damperi ochilmadi",
				FireDamperOpen: "Yong'in damperi ochiq",
				FireDamperNotOpened: "Yong'in damperi ochılmadı",
				'New sensor data in carrier № ':
					"Yangi datchik ma'lumoti, vagon № ",
				'Click to see more': "Ko'proq ko'rish uchun bosing",
				SelectCarrier: 'Vagonni tanlang',
				TestMode: 'TEST REJIMIDA',
				LastCarrierData: "Oxirgi vagon ma'lumotlari",
				LastCarrierDataAll:
					"Barcha oxirgi vagon ma'lumotlari",
				ShowLastUpdatedFirst:
					"So'nggi yangilanganlarni birinchi ko'rsatish",
				NoData: "Ma'lumot yo'q",
				ERR: 'Avariya: ',
				Yes: 'Xa',
				No: "Yo'q",
				Continue: 'Davom etish',
				GoAhead: 'Davom etish!',
				GoHome: 'Asosiy menu',
				GoBack: 'Orqaga qaytish',
				PageNotFound:
					'Kechirasiz, siz tashrif buyurgan sahifa mavjud emas.',
				'Authentication Required':
					'Autentifikatsiya talab qilinadi',
				'To access this content, you need to authenticate first. Please login through SmartDepo platform to acquire the necessary tokens.':
					"Ushbu kontentga kirish uchun avval autentifikatsiyadan o'tishingiz kerak. Zarur tokenlarni olish uchun SmartDepo platformasi orqali tizimga kiring.",
				'Authentication URL': 'Autentifikatsiya URL manzili',
				'Refresh Page': "Sahifani yangilab ko'rish",
				'Login Now': 'Hozir kirish',
				'After successful authentication, your tokens will be automatically stored and you can access the content.':
					"Muvaffaqiyatli autentifikatsiyadan so'ng, tokenlaringiz avtomatik ravishda saqlanadi va siz kontentga kira olasiz.",
				'Refreshing Tokens...': 'Tokenlar yangilanmoqda...',
				'Please wait while we refresh your authentication tokens...':
					'Autentifikatsiya tokenlaringizni yangilayotgan vaqtda kuting...',
				'Try Refresh Token': "Refresh tokenni sinab ko'ring",
				Online: 'Onlayn',
				Offline: 'Oflayn',
				NetworkPanelDisconnected: "Pult bilan aloqa yo'q",
				NetworkPanelAlertTitle: "Pult bilan aloqa yo'q",
				NetworkPanelAlertBody:
					'Quyidagi vagonlar bilan aloqa uzildi:',
				Acknowledge: 'Qabul qilindi',
				Count: 'Soni'
			}
		},
		kz: {
			translation: {
				Welcome:
					'Өзбекстан темір жолының онлайн мониторинг қосымшасына қош келдіңіз!',
				Monitoring: 'Мониторинг',
				Search: 'Іздеу',
				'Sensors Group': 'Сенсорлар тобы',
				'Have a nice day!': 'Күніңіз әрі қонақты болсын!',
				Heating: 'Жылу',
				'High voltage heating 3000 V':
					'Жоғары токтардың 3000 В жылуы',
				ElectricHeater: 'Электр жылуы',
				LowVoltHeater: 'Төмен кернеулі жылу',
				Conditioning: 'Кондиционер',
				ClimateControl: 'Жылу назариясы',
				Auto: 'Авто',
				Manual: 'Қолмен',
				Specified: 'Анықталған',
				Coupe: 'Купе',
				Outdoor: 'Сыртқы',
				SupplyFan: 'Тасымалдау желісі',
				HighPressure: 'Жоғары тыңдау',
				LowPressure: 'Төмен тыңдау',
				CompressorFrequency: 'Компрессор частотасы',
				'Damper 1 open': 'Заслонка 1 ашық',
				'Damper 1 closed': 'Заслонка 1 жабық',
				'Damper 2 open': 'Заслонка 2 ашық',
				'Damper 2 closed': 'Заслонка 2 жабық',
				WaterBoiler: 'Су қыздырғыш',
				Temperature: 'Температура',
				Aqualite: 'Аквалит',
				Megalith: 'Мегалит',
				Megalit: 'Мегалит',
				'Drinking water tank': 'Ішімді су таны',
				MainLightning: 'Негізгі жарық',
				EmergencyLighting: 'Авариялық жарық',
				'Enter/exit': 'Кіру/шығу',
				Capacitor: 'Конденсатор',
				Compressor: 'Компрессор',
				HighHeat: 'Жоғары жылу',
				LowHeat: 'Төмен жылу',
				Calorifer: 'Калорифер',
				Climate: 'Жылу',
				RNG: 'РНГ',
				PCH: 'ПЧ',
				ThermalSensors: 'Термодатчиктер',
				ThermalSensor: 'Термодатчик',
				Timers: 'Таймерлер',
				SensorInversion: 'Датчик инверсиясы',
				WaterAvailablity: 'Су қолжетімділігі',
				WaterTemperature: 'Су температурасы',
				WaterTank: 'Су таны',
				PressureSensors: 'Тыңдау датчиктері',
				SensorNotConfigured: 'Сенсордың сынуы',
				SensorHighConfigured: 'Жоғары басымдық сенсоры',
				SensorLowConfigured: 'Төмен басымдық сенсоры',
				ResetResource: 'Ресурсты қайта орнату',
				Status: 'Мәртебесі',
				LastSeenAt: 'Соңғы байланыс',
				DELIXI: 'DELIXI',
				NoAccidents: 'Авариялар жоқ',
				RNGSensors: 'РНГ датчиктері',
				ExcitationWinding: 'Қозғалту жүргізу',
				Controller: 'Басқарушы',
				CarrierSpeed: 'Көлік жылуы',
				BatteryType: 'Батарея түрі',
				BatteryTemperature: 'Батарея температурасы',
				CheckTheBalance: 'Балансты тексеріңіз',
				Power: 'Қуат',
				Battery: 'Батарея',
				Батарея: 'Батарея',
				Генератор: 'Генератор',
				VoltageNetwork: 'Желі жарықтың денесі',
				Volt: 'В',
				Degree: '°C',
				AmperageNetwork: 'Желі жарықтың амперажы',
				Amp: 'А',
				AmperageBattery: 'Батарея амперажы',
				TemperatureBattery: 'Батарея температурасы',
				Control: 'Басқару',
				ControllerManagement: 'Басқарушы басқаруы',
				RNGControl: 'РНГ басқаруы',
				InternalCommunication: 'Ішкі байланыс',
				LeftDoor: 'Сол жақты есік',
				RightDoor: 'Оң жақты есік',
				Protection: 'Қорғау',
				VTS: 'ВТС',
				VTB: 'ВТБ',
				VNS: 'ВНС',
				'MIN.1': 'МИН.1',
				'MIN.2': 'МИН.2',
				SideProtOver: 'Букс қызыуы',
				Carriers: 'Вагондар',
				NewCarrier: 'Жаңа вагон',
				Loading: 'Жүктелуде',
				CurrentIndications: 'Ағымды көрсеткіштер',
				Logging: 'Логлау',
				Diagram: 'Диаграмма',
				Description: 'Сипаттама',
				Submit: 'Сақтау',
				changePassword: 'Құпия сөзді өзгерту',
				oldPassword: 'Ескі құпия сөз',
				newPassword: 'Жаңа құпия сөз',
				confirmPassword: 'Құпия сөзді растау',
				Cancel: 'Болдырмау',
				'INPUT №': 'КІРУ №',
				'OUTPUT №': 'ШЫҒУ №',
				Notifications: 'Хабарландырулар',
				MarkAllAsRead: 'Барлығын оқылған деп белгілеу',
				uploadPhoto: 'Фото жүктеу',
				MaximalVoltage: 'Максималды дене',
				ViewCarrier: 'Вагонды қарау',
				Name: 'Атауы',
				FactoryNumber: 'Завод нөмірі',
				Save: 'Сақтау',
				IsDeleted: 'Жойылған',
				Delete: 'Жою',
				Restore: 'Қалпына келтіру',
				Redirecting: 'Жөнелту',
				Login: 'Кіру',
				ProfileImage: 'Профиль суреті',
				fullname: 'Аты-жөні',
				position: 'Лауазым',
				role: 'Роль',
				Sensors: 'Сенсорлар',
				AddingNewSensor: 'Жаңа сенсор қосу',
				Code: 'Код',
				Measurement: 'Өлшем',
				Type: 'Тип',
				ViewSensor: 'Сенсорды қарау',
				ViewUser: 'Пайдаланушыны қарау',
				AddUser: 'Пайдаланушы қосу',
				Email: 'Электрондық пошта',
				Users: 'Пайдаланушылар',
				UserName: 'Пайдаланушы аты',
				Logout: 'Шығу',
				Home: 'Басты бет',
				Lightning: 'Жарық',
				Consumers: 'Тұтынушылар',
				Climat: 'Жылу',
				Settings: 'Параметрлер',
				MaxNetworkVoltage: 'Максималды желі денесі',
				NetworkVoltage: 'Желі денесі',
				NetworkCurrent: 'Желі амперажы',
				BatteryCurrent: 'Батарея амперажы',
				Timer: 'Таймер',
				'WorkTime 1': 'Жұмыс уақыты 1',
				'WorkTime 2': 'Жұмыс уақыты 2',
				sec: 'сек',
				hour: 'сағат',
				'StopDC-DC': 'Стоп DC-DC',
				ChargeCapacitor: 'Конденсаторды зарядтау',
				'StartDC-DC': 'DC-DC старт',
				'WorkDC-DC': 'DC-DC жұмыс',
				Work380V: '380 В жұмыс',
				NotEnoughVoltage: 'Дене жетпейді',
				PCHDrawerOpen: 'PCH шулуғы ашық',
				StopSupply: 'Стоп приточка',
				StartSupply: 'Приточка старт',
				WorkSupply: 'Приточка жұмыс',
				Overvoltage: 'Аса кернеу',
				'DC-DCFault': 'DC-DCда қате',
				StopCondensator: 'Стоп конденсатор',
				StartCondensator: 'Конденсатор старт',
				WorkCondensator: 'Конденсатор жұмыс',
				HighCurrent: 'Жоғары ток',
				Overheat75: '75° қызып кету',
				StopCompressor: 'Стоп компрессор',
				StartCompressor: 'Компрессор старт',
				WorkCompressor: 'Компрессор жұмыс',
				ProtectionTemp: '°C бойынша қорғау',
				AnalogModule: 'Аналогды модуль',
				inputVoltage: 'Кіру денесі',
				DrawerTemp: 'Шулуқ температурасы',
				Chastota: 'Частота',
				Voltage: 'Дене',
				Current: 'Ток',
				'DC-DCVoltage': 'DC-DC денесі',
				Hz: 'Гц',
				InputAmper: 'Кіру амперажы',
				VoltageAdjustment110: '110 V денесін қалайту',
				VoltageAdjustment450: '450 V денесін қалайту',
				MaximalCurrent: 'Максималды ток',
				CurrentSensorAdjustment: 'Сенсор амперажын қалайту',
				TempSensorAdjustment: 'Сенсор температурасын қалайту',
				Work: 'Жұмыс',
				CarrierName: 'Вагон атауы',
				CanView: 'Көру мүмкін',
				CanViewSettings: 'Параметрлер',
				EditCarrier: 'Вагонды өңдеу',
				Actions: 'Әрекеттер',
				NoResults: 'Нәтижелер жоқ',
				Balance: 'Баланс',
				ReplanishmentDate: 'Толтыру күні',
				BalanceOfCarrier: 'Вагон балансы',
				WaterOverheat: 'Су қызып кетуі',
				LastUpdate: 'Соңғы жаңарту',
				UpdateNow: 'Қазір жаңарту',
				CarrierPermission: 'Вагон рұқсаты',
				'Coming Soon!': 'Жақында келеді!',
				Time: 'Уақыт',
				Source: 'Дереккөз',
				Lighting: 'Жарықтандыру',
				'PCH Overheat': 'PCH қызып кетуі',
				Aqualit: 'Аквалит',
				Remote: 'Қашықтан',
				App: 'Қолданба',
				EventText: 'Оқиға мәтіні:',
				EventLog: 'Оқиғалар журналы',
				AllCarriers: 'Барлық вагондар',
				TotalEvents: 'Барлық оқиғалар',
				Filtered: 'Сүзгіленген',
				Refresh: 'Жаңарту',
				Export: 'Экспорт',
				Total: 'Барлығы',
				Recent: 'Ажа',
				ViewAll: 'Барлығы көрсету',
				UniqueEvents: 'Бірегей',
				First: 'Бірінші',
				LoggingCodes: 'Лог кодтары',
				AddCode: 'Код қосу',
				EditCode: 'Кодты өзгерту',
				IsError: 'Қате',
				Notify: 'Хабарлама',
				ConfirmDelete: 'Жоюды растайсыз ба?',
				Edit: 'Өзгерту',
				SavedSuccessfully: 'Сәтті сақталды',
				CreatedSuccessfully: 'Сәтті жасалды',
				CodeRequired: 'Кодты енгізіңіз',
				DeletedSuccessfully: 'Сәтті жойылды',
				ErrorLoadingData: 'Деректерді жүктеу қатесі',
				ErrorDeletingData: 'Жою қатесі',
				FireDamperClosed: 'Өрт сөндіруші жабық',
				FireDamperOpen: 'Өрт сөндіргіші ашық',
				FireDamperNotOpened: 'Өрт сөндіргіші ашылмады',
				'New sensor data in carrier № ':
					'Жаңа сенсор деректері, № тасымалдаушыда',
				'Click to see more': 'Толығырақ көру үшін басыңыз',
				SelectCarrier: 'Каретканы таңдаңыз',
				TestMode: 'СЫНАҚ РЕЖИМІ',
				LastCarrierData: 'Соңғы тасымалдаушы деректері',
				LastCarrierDataAll:
					'Барлық соңғы тасымалдаушы деректері',
				ShowLastUpdatedFirst:
					'Соңғы жаңартылғанды бірінші көрсетіңіз',
				NoData: 'Мәліметтер жоқ',
				ERR: 'Авария: ',
				Yes: 'Иә',
				No: 'Жоқ',
				Continue: 'Жалғастыру',
				GoAhead: 'Алға!',
				GoHome: 'Негізгі бет',
				GoBack: 'Қайтып келу',
				PageNotFound: 'Кешіріңіз, сіз кірген бет жоқ.',
				'Authentication Required': 'Аутентификация қажет',
				'To access this content, you need to authenticate first. Please login through SmartDepo platform to acquire the necessary tokens.':
					'Бұл мазмұнға қол жеткізу үшін алдымен аутентификациядан өту керек. Қажетті токендерді алу үшін SmartDepo платформасы арқылы кіріңіз.',
				'Authentication URL': 'Аутентификация URL мекенжайы',
				'Refresh Page': 'Бетті жаңарту',
				'Login Now': 'Қазір кіру',
				'After successful authentication, your tokens will be automatically stored and you can access the content.':
					'Сәтті аутентификациядан кейін сіздің токендеріңіз автоматты түрде сақталады және сіз мазмұнға қол жеткізе аласыз.',
				'Refreshing Tokens...': 'Токендерді жаңарту...',
				'Please wait while we refresh your authentication tokens...':
					'Аутентификация токендеріңізді жаңартып жатқанда күте тұрыңыз...',
				'Try Refresh Token': 'Refresh токенді қолданып көру',
				Online: 'Онлайн',
				Offline: 'Офлайн',
				NetworkPanelDisconnected: 'Пульпен байланыс жоқ',
				NetworkPanelAlertTitle: 'Пульпен байланыс жоқ',
				NetworkPanelAlertBody:
					'Келесі вагондармен байланыс үзілді:',
				Acknowledge: 'Қабылданды',
				Count: 'Саны'
			}
		}
	},
	lng: language,
	fallbackLng: 'ru',

	interpolation: {
		escapeValue: false
	}
})

i18next.on('languageChanged', (lng: string) => {
	localStorage.setItem('language', lng)
})

if (!localStorage.getItem('language')) {
	localStorage.setItem('language', 'en')
}

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
)

reportWebVitals()
// eruda.init()
